import { tw } from "@careinfo/tailwind";
import { useFieldArray } from "react-hook-form";
import CrossIcon from "../../Icons/CrossIcon";
import APIS from "../../constant/Endpoint";
import ArrayComboboxInput from "../Reusable/ArrayComboboxInput";
import CreateComboboxInput from "../Reusable/CreateComboboxInput";
import FormDatePicker from "../Reusable/DateField";
import FileUpload from "../Reusable/FileUpload";
import NpDatePicker from "../Reusable/NepaliDatePicker";
import NumberField from "../Reusable/NumberField";
import TextAreaField from "../Reusable/TextAreaField";
import TextField from "../Reusable/TextField";

const Form = (props: any) => {
  const {
    control,
    register,
    errors,
    getValues,
    setValue,
    clearErrors,
    fields,
    handleAddRow,
    remove,
    isEdit,
    watch,
    setOpenAccountPopup,
    isDraft = true,
  } = props;

  const values = watch("journal_account")
  const debit = values?.reduce((acc, curr) => acc + (Number(curr.debit) || 0), 0);
  const credit = values?.reduce((acc, curr) => acc + (Number(curr.credit) || 0), 0);

  return (
    <div className={tw`px-4`}>
      <div className={tw`grid grid-cols-3  gap-x-4 `}>
        {isEdit ? (
          <TextField
            label="Voucher Number"
            control={control}
            name={"seq_no"}
            placeholder="Enter Sequence Number"
            disabled={true}
          />
        ) : (
          <TextField
            label="Voucher Number"
            control={control}
            name={"number_series"}
            placeholder="Enter Number Series"
            disabled={true}
          />
        )}
        <NpDatePicker
          label="Miti"
          name="voucher_date"
          disabled={!isDraft}
          disableFuture={true}
          value={watch("voucher_date")}
          setValue={setValue}
          error={errors?.voucher_date}
        />

        <FormDatePicker
          label="Date"
          name="voucher_date"
          disabled={!isDraft}
          control={control}
        />
      </div>
      <div className={tw`grid grid-cols-2 gap-x-6`}>
        <p className={tw`font-semibold`}>Ledger Accounts</p>
        <div className={tw`grid grid-cols-2 gap-x-2`}>
          <p className={tw`font-semibold`}>Debit</p>
          <p className={tw`font-semibold`}>Credit</p>
        </div>
      </div>
      <div id="sub-product">
        {fields.map((field: any, index: any) => {
          return (
            <div key={index}>
              <div className={tw`grid grid-cols-2 gap-x-6 mb-1 w-full`}>
                <div className={tw`w-full flex  space-x-1`}>
                  <ArrayComboboxInput
                    url={APIS.COA}
                    queryKey={"ledger-account"}
                    register={register(`journal_account.${index}.account`)}
                    errors={errors?.journal_account?.[index]?.account}
                    name={`journal_account.${index}.account`}
                    // label={"Account 1"}
                    setValue={setValue}
                    props={{
                      is_active: true,
                      is_group: false,
                    }}
                    disabled={!isDraft}
                    value={getValues(`journal_account.${index}.account`)}
                    placeholder={"Search account"}
                    clearErrors={clearErrors}
                  />
                  <button
                    className={tw`border px-3 h-9 text-xl leading-0 relative top-2  bg-[#EEF5F4] focus:outline-none`}
                    type="button"
                    onClick={() => setOpenAccountPopup((prev) => !prev)}
                  >
                    +
                  </button>
                </div>
                <div className={tw`flex gap-x-2  w-full`}>
                  <div className={tw`grid grid-cols-2 w-full gap-x-4 `}>
                    <NumberField
                      value={getValues(`journal_account.${index}.debit`)}
                      register={register(`journal_account.${index}.debit`)}
                      errors={errors?.journal_account?.[index]?.debit}
                      delimiter=","
                      // label={"Debit"}
                      setValue={setValue}
                      disabled={!isDraft}
                      clearErrors={clearErrors}
                    />
                    <NumberField
                      value={getValues(`journal_account.${index}.credit`)}
                      register={register(`journal_account.${index}.credit`)}
                      errors={errors?.journal_account?.[index]?.credit}
                      // label={"Credit"}
                      delimiter=","
                      setValue={setValue}
                      clearErrors={clearErrors}
                      disabled={!isDraft}
                    />
                  </div>
                  <button
                    type="button"
                    className={tw`rounded p-1 h-8 mt-2  border border-gray-400 text-xs`}
                    disabled={index === 1 || index === 0 || !isDraft}
                    onClick={() => remove(index)}
                  >
                    <CrossIcon />
                  </button>
                </div>
              </div>
              <hr />
            </div>
          );
        })}
        <div className={tw`w-full grid grid-cols-2 mt-1 gap-x-6`}>
          <div>
            <button
              type="button"
              disabled={!isDraft}
              className={tw`rounded p-1 my-2 border border-gray-400 text-xs`}
              onClick={() => handleAddRow()}
            >
              Add Row
            </button>
          </div>
          <div className={tw`w-full grid grid-cols-2 gap-x-4 mr-6`}>
            <NumberField
              value={debit}
              delimiter=","
              setValue={setValue}
              clearErrors={clearErrors}
              disabled={true}
            />
            <NumberField
              value={credit}
              delimiter=","
              setValue={setValue}
              clearErrors={clearErrors}
              disabled={true}
            />
          </div>
        </div>
        <div>
          {errors?.journal_account?.root?.message && (
            <span
              className={tw`text-red-500 text-xs flex items-center gap-x-1 mt-2`}
            >
              <span className={tw`block`}>
                {errors.journal_account.root.message as string}
              </span>
            </span>
          )}
        </div>
      </div>
      <div className={tw`grid grid-cols-2 gap-x-6`}>
        <CreateComboboxInput
          url={APIS.SALES_PURCHASE}
          queryKey="sales"
          label={"Reference No."}
          props={{}}
          register={register("reference_number")}
          errors={errors?.reference_number}
          setValue={setValue}
          disabled={!isDraft}
          name={"reference_number"}
          salesDate={"reference_date"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <div className={tw`mt-3`}>
          <NpDatePicker
            label="Reference Date"
            name="reference_date"
            disabled={!isDraft}
            value={watch("reference_date")}
            setValue={setValue}
            error={errors?.reference_date}
          />
        </div>
        <FileUpload
          label="Attachment"
          register={register("attachment")}
          watch={watch}
          errors={errors}
          disabled={!isDraft}
          setValue={setValue}
        />
        <TextAreaField
          label="Narration"
          control={control}
          disabled={!isDraft}
          name={"narration"}
          placeholder="Write notes here..."
        />
      </div>
    </div>
  );
};

export default Form;
